import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LoginPage from './pages/loginPage';
import RegisterForm from './pages/RegisterPage';
import Home from './pages/Home';
import AboutUs from './pages/Aboutus';  
import Gallery from './pages/Gallery';
import Leadership from './pages/Leadership';
import Membership from './pages/Membership';
import LandingPage from './pages/Landingpage';
import { AuthProvider } from './context/AuthContext'; 
import Profile from './pages/profilepage';
import Paymentgateway1 from "./pages/Paymentgateway1";
import Paymentgateway2 from "./pages/Paymentgateway2";
import Manageusers from './pages/Managusers';
import Manageuser from './pages/Manageuser';
import Userprofile from './pages/Userprofile';
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Whatsnext from "./pages/Whatsnext";
import Help from "./pages/Help";
import Receipt from "./pages/Receipt";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AnimatePresence } from "framer-motion";
import PageWrapper from "./components/PageWrapper"; 
import ChangePassword from "./components/ChangePassword"; 
// import the wrapper
import Profilepage from "./pages/profile";// import the wrapper

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/login" element={<PageWrapper><LoginPage /></PageWrapper>} />
        <Route path="/register" element={<PageWrapper><RegisterForm /></PageWrapper>} />
        <Route path="/aboutus" element={<PageWrapper><AboutUs /></PageWrapper>} />
        <Route path="/gallery" element={<PageWrapper><Gallery /></PageWrapper>} />
        <Route path="/leadership" element={<PageWrapper><Leadership /></PageWrapper>} />
        <Route path="/landing" element={<PageWrapper><LandingPage /></PageWrapper>} />
        <Route path="/profile" element={<PageWrapper><Profile /></PageWrapper>} />
        <Route path="/paymentgateway" element={<PageWrapper><Paymentgateway1 /></PageWrapper>} />
        <Route path="/paymentgateway2" element={<PageWrapper><Paymentgateway2 /></PageWrapper>} />
        <Route path="/manageusers" element={<PageWrapper><Manageusers /></PageWrapper>} />
        <Route path="/membership" element={<PageWrapper><Membership /></PageWrapper>} />

        <Route path="/userprofile" element={<PageWrapper><Userprofile /></PageWrapper>} />
        <Route path="/terms" element={<PageWrapper><Terms /></PageWrapper>} />
        <Route path="/privacy" element={<PageWrapper><Privacy /></PageWrapper>} />
        <Route path="/whatsnext" element={<PageWrapper><Whatsnext /></PageWrapper>} />
        <Route path="/help" element={<PageWrapper><Help /></PageWrapper>} />
        <Route path="/receipt" element={<PageWrapper><Receipt /></PageWrapper>} />
        <Route path="/completemyprofile" element={<PageWrapper><Profilepage /></PageWrapper>} />
        <Route path="/change-password" element={<PageWrapper><ChangePassword /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <AnimatedRoutes />
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
